import { type FC } from "react";
import { useUserDetailContents } from "@clientFrontend/features/scout/hooks/useUserDetailContents";
import { useUserHidden } from "@clientFrontend/features/scout/hooks/useUserHidden";
import { Presentation } from "./Presentation";

type Props = {
  fetchUrl: string;
  isShow: boolean;
  onClose: () => void;
  isShowScoutNavigation: boolean;
  isHiddenInitialValue?: boolean;
  hiddenScoutUrl?: string;
  userId?: string;
};

export const UserDetailModalSp: FC<Props> = ({
  fetchUrl,
  isShow,
  onClose,
  isShowScoutNavigation,
  isHiddenInitialValue,
  hiddenScoutUrl,
  userId,
}) => {
  const { isHidden, isLoading, postUserData } = useUserHidden(isHiddenInitialValue);

  const onClickUserHiddenTrigger = () => {
    if (userId === undefined || isHidden === undefined || hiddenScoutUrl === undefined) return;
    postUserData(userId, isHidden, hiddenScoutUrl);
  };

  const userHiddenButtonContent = {
    isHidden,
    isLoading,
    onClickUserHiddenTrigger,
  };

  const formattedData = useUserDetailContents(fetchUrl);

  if (!formattedData) return null;

  return (
    <Presentation
      formattedData={formattedData}
      isShow={isShow}
      onClose={onClose}
      isShowScoutNavigation={isShowScoutNavigation}
      userHiddenButtonContent={userHiddenButtonContent}
    />
  );
};
